import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-toggle-hidden-visibility',
    host: { 'data-app': 'mgmt' },
    templateUrl: './toggle-hidden-visibility.component.html',
    styleUrls: ['./toggle-hidden-visibility.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToggleHiddenVisibilityComponent implements OnInit {
  @Input() data: any;
  @Input() placeholder: string = '**********';s
  showData: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
